import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';

export default class PageVideoSplash extends Component {
	
	constructor(){
		super()
		this.state = {
			index:0,
			started:false,
		}
		this.curVideo 		= React.createRef();
		this.startVideo 	= this.startVideo.bind(this);
		this.videoPlaying 	= this.videoPlaying.bind(this);
		this.hangleToggle 	= this.handleToggle.bind(this);
	}


	componentDidMount() {
		setTimeout(() => {
			this.startVideo();
		}, 500);
  	}
  	handleToggle(_evt) {  
	    let time = (parseInt(_evt.currentTarget.getAttribute('data-activate-at')) / 1000) + 0.1;
	    document.getElementById('splash-video').currentTime = time;
    }
  	startVideo() {
		this.curVideo.current.play();
	} 	
	videoPlaying() {
		
		this.curVideo.current.style.display = 'block';
		
		if (this.state.started === false) {
			this.setState({
				started: true
			})
		} else {
			
			let foundIndex 	= 0;
			let index 		= this.state.index;
			let currentTime = this.curVideo.current.currentTime * 1000;
						
			for (let i=0;i<this.props.block.slides.length;i++) {
				
				if (parseInt(this.props.block.slides[i].activate_at) < currentTime) {
					foundIndex = i;
				}
			}
			
			if (foundIndex !== index) {
				this.setState({
					started: 	true,
					index: 		foundIndex,
				});
			}
		}
	}
  		
	render() {
		
		let block = this.props.block;
		let siteLoaded = this.props.siteLoaded;
		
		let playClass = '';
		if (this.state.started === true) {
			playClass = 'state-playing';
		}
		
		if (block.slides) {
				
			const slides = block.slides.map((slide,i) =>
				{
					let slideClass = 'c-video-splash__slide';
					if (i === this.state.index) {
						slideClass = slideClass + ' state-active';
					}
					return (
						<div className={slideClass} key={i}>
							<div className="c-video-splash__slide__inner" key={i}>
								<h2 className="c-video-splash__slide__heading" dangerouslySetInnerHTML={{__html:slide.heading}}></h2>
								<p className="c-video-splash__slide__elevation" dangerouslySetInnerHTML={{__html:slide.elevation}}></p>
								<p className="c-video-splash__slide__location" dangerouslySetInnerHTML={{__html:'<span>' + slide.location + '<span>'}}></p>
								<p className="c-video-splash__slide__season" dangerouslySetInnerHTML={{__html:slide.season}}></p>
								<p className="c-video-splash__slide__time" dangerouslySetInnerHTML={{__html:slide.time}}></p>
							</div>
						</div>
					)
				}
			);

			return (				
				
				<div className={'c-page__block c-page__block--splash c-page__block--space-' + block.space_after}>
					<div className={'c-video-splash ' + playClass}>
						<video id="splash-video" className="c-video-splash__video" style={{display:'none'}} ref={this.curVideo} src={block.video} onTimeUpdate={this.videoPlaying} playsInline muted loop></video>
						{block.first_src &&
							<img className="c-video-splash__first-frame" src={block.first_src} alt="" />
						}
						{slides}
						<div className="c-video-splash__markers">
							{block.slides.map((slide,i) =>
								{
									return(
										<>
											{i === this.state.index &&
												<p className="c-video-splash__markers__dot state-active" key={i}><span>{slide.elevation}</span></p>
											}
											{i !== this.state.index &&
												<p className="c-video-splash__markers__dot" data-activate-at={slide.activate_at} onClick={this.handleToggle} key={i}><span>{slide.elevation}</span></p>
											}
										</>
									)
								}
							)}
						</div>
						
					</div>
				</div>
									
			);
			
		} else {
			return null;
		}
	}
}